export default __webpack_public_path__ + "static/waterfall_dark-ab4a891d1961307879417cbb3aeff6cd.gif";